import { useTranslation } from '@frontend/i18n';
import { StaticVerticalStepper, StaticVerticalStepperContent } from '@frontend/static-vertical-stepper';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { UndefinedOrNull } from '../utils/types';

interface HistoryProps {
  stepsData: UndefinedOrNull<StaticVerticalStepperContent[]>;
}

export const History = ({ stepsData }: HistoryProps) => {
  const { t } = useTranslation();
  if (!stepsData) return null;
  return (
    <section css={{ padding: theme.spacing(2, 2, 1) }}>
      <Heading level={3} css={{ marginBottom: theme.spacing(3) }}>
        {t('History')}
      </Heading>
      <StaticVerticalStepper stepsInfo={stepsData} />
    </section>
  );
};
History.displayName = 'History';
